import React, { useState, useEffect } from "react";
import { useLocation, Switch, Redirect, useHistory } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";

import ReseMonitoringRequestLogs from "./monitoring-request-logs/ReseMonitoringRequestLogs";
import ReseLeakDetectionMonitoringRequest from "./monitoring-request/ReseLeakDetectionMonitoringRequest";
import "./ReseLeakDetectionMonitoring.scss";

const BASE_PATH = "/admin/rese/leak-detection-monitoring";
const MONITORING_REQUEST_PATH = `${BASE_PATH}/monitoring-request`;
const MONITORING_REQUEST_LOGS_PATH = `${BASE_PATH}/monitoring-request-logs`;

const ReseLeakDetectionMonitoring = () => {
    const { pathname, search } = useLocation();
    const history = useHistory();
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (pathname === MONITORING_REQUEST_PATH) {
            setActiveIndex(0);
        } else if (pathname === MONITORING_REQUEST_LOGS_PATH) {
            setActiveIndex(1);
        }
    }, [pathname]);

    const handleTabChange = (e) => {
        if (e.index === 0) {
            setActiveIndex(0);
            history.push({ pathname: MONITORING_REQUEST_PATH, search });
        } else if (e.index === 1) {
            setActiveIndex(1);
            history.push({ pathname: MONITORING_REQUEST_LOGS_PATH });
        }
    };

    return (
        <div className="rese-leak-detection-monitoring-container" style={{ width: "100%" }}>
            <p className="page-label" style={{ padding: "22px 18px 0 18px" }}>
                RESE <i className="pi pi-angle-right" /> Leak Detection Monitoring
            </p>
            <TabView
                activeIndex={activeIndex}
                onTabChange={handleTabChange}
                className="container-fluid"
            >
                <TabPanel header="Monitoring Request">
                    <ReseLeakDetectionMonitoringRequest />
                </TabPanel>
                <TabPanel header="Monitoring Request Logs">
                    <ReseMonitoringRequestLogs />
                </TabPanel>
            </TabView>
            <Switch>
                <Redirect
                    exact
                    path={BASE_PATH}
                    to={{
                        pathname: MONITORING_REQUEST_PATH,
                        search
                    }}
                />
            </Switch>
        </div>
    );
};

export default ReseLeakDetectionMonitoring;
